import React from 'react';
import { Spacer, ContentBoxContainer, ContentBoxText, ContentBoxFigure, PenlySeo, Decoline } from 'components';
import { mediaQueries, fromTablethoriMediaQuery } from 'utils/MediaQueriesDeprecated';

export default function Partners() {
    const title = 'Skab værdi og større tilfredshed for jeres medlemmer med Penly';
    const description =
        'Brug Penly som et værdiskabende tilbud for jeres medlemsorganisation, virksomhed eller forening. Få attraktive rabatter på uvildig rådgivning nu.';
    const image = { url: '/static/gfx/content/penly-content-4.jpg' };
    const fromTablethori = mediaQueries(fromTablethoriMediaQuery);

    return (
        <>
            <PenlySeo title={ title } description={ description } image={ image } />
            <ContentBoxContainer className="fluid">
                <ContentBoxText>
                    <h1 className="nomb">
                        Skab <span className="color-highlight">værdi</span> for jeres medlemmer med Penly
                    </h1>
                    <p className="large">
                        Hos Penly er det vores mål at gøre det nemt for privatpersoner at tage ejerskab over deres økonomi. Det gør vi ved at stille værktøjer til rådighed, som gør brugeren bevidst om
                        de muligheder, der er for at forbedre deres økonomi. Brugerne har 100% ejerskab over deres data.
                    </p>
                </ContentBoxText>
                <ContentBoxFigure className="penlylogoSymbolTeal"></ContentBoxFigure>
            </ContentBoxContainer>

            <ContentBoxContainer>
                <ContentBoxFigure figure="/static/gfx/content/penly-content-23.jpg" className="brbr"></ContentBoxFigure>
                <ContentBoxText>
                    <h3>Partnerskaber med Penly</h3>
                    <p>
                        Penly indgår partnerskaber, der gør det muligt for medlemsorganisationer og foreninger at tilbyde Penlys værktøjer til deres medlemmer, som giver dem attraktive rabatter på
                        uvildig rådgivning.
                    </p>
                    <p>Et samarbejde med Penly er en effektiv værdiskabende ydelse, som I kan tilbyde jeres medlemmer og på den måde knytte jeres medlemmer endnu tættere til jer.</p>
                </ContentBoxText>
            </ContentBoxContainer>

            { fromTablethori ? <Spacer size="huge" /> : <Spacer /> }

            <ContentBoxContainer className="mobileflip">
                <ContentBoxText>
                    <h3>Penly samarbejder med Forbrugerrådet Tænk</h3>
                    <p>
                        I samarbejde med Forbrugerrådet Tænk tilbyder vi deres medlemmer adgang til platformen samt attraktive rabatter på uvildig rådgivning. Tænks medlemmer har taget godt imod
                        tilbuddet og roser Tænk for initiativet.
                    </p>
                </ContentBoxText>
                <ContentBoxFigure className="brbr brtl background-affiliate-taenk servicelogo" figure="/static/gfx/content/affiliates/forbrugerraadet-taenk-logo-white.svg"></ContentBoxFigure>
            </ContentBoxContainer>

            <Spacer size="large" />

            <ContentBoxContainer className="mobileflip">
                <ContentBoxText className="background-affiliate-taenk quote brbl">
                    <p>
                        <div>
                            Vores medlemmer har taget rigtig godt imod Penlys PensionsTjek. Jeg var lidt skeptisk over, om medlemmerne ville tage det til sig, men vi har nogle langt bedre resultater
                            end det, vi normalt oplever med denne type samarbejder. Vi er meget tilfredse med samarbejdet med Penly, som har været nemt og gnidningsfrit.
                            <br />
                            <br />
                            <strong>Claus Brøgger, Marketingchef</strong>
                            <br />
                            Forbrugerrådet Tænk
                        </div>
                    </p>
                    <Decoline color="white" />
                </ContentBoxText>
                <ContentBoxFigure figure="/static/gfx/content/penly-content-forbrugerraadet-taenk-claus-broegger.jpg" className="background-primary brtr"></ContentBoxFigure>
            </ContentBoxContainer>

            { fromTablethori ? <Spacer size="huge" /> : <Spacer /> }

            <ContentBoxContainer>
                <ContentBoxFigure className="brbr brtl centered">
                    <img src="/static/gfx/PenlyLogo.svg" />
                </ContentBoxFigure>
                <ContentBoxText>
                    <h3>Hvordan kan vi hjælpe jer?</h3>
                    <p>
                        Et partnerskab med Penly kan spænde fra et simpelt samarbejde, hvor I gør jeres medlemmer opmærksomme på muligheden for at blive klogere på deres privatøkonomi på penly.dk, til
                        et udvidet partnerskab, hvor vi tilbyder attraktive rådgivningspakker til jeres medlemmer.
                    </p>
                    <p>
                        Vil du høre mere om mulighederne for partnerskaber, så kontakt Kourosh Rasmussen på <a href="mailto:kourosh@penly.dk">kourosh@penly.dk</a>
                        &nbsp;eller på <a href="tel:+4540866164">+45 40 86 61 64</a>. Du kan ringe til os tirsdag og torsdag mellem 10.00 og 14.00.
                    </p>
                </ContentBoxText>
            </ContentBoxContainer>

            <Spacer />
        </>
    );
}
